module.exports = __webpack_public_path__ + "static/media/all-video-polygon.9679b1e6.png";